import {
  AutomationConditionItem,
  AutomationConditionModel,
  BaseAutomationConditionModel,
  SelectedCondition,
} from './automation-condition.model';
import { EvidenceAutomationConditionItem } from 'src/app/admin/admin-home/admin-credentials/admin-credential-scenario/admin-credential-scenario-details/admin-requirement-side-bar/evidence-automation-condition-item';
import { OPERATORS } from '../odata-filter/models/operators';

export function createSelectedCondition(
  condition: AutomationConditionModel,
  availableConditions: EvidenceAutomationConditionItem[],
  initSelectedCondition: (
    searchValue: string[],
    filterOperator: any,
    filter: AutomationConditionItem
  ) => { searchValues?: any[]; searchValue?: string }
): SelectedCondition {
  const filter = availableConditions.find((x) => x.objectId === condition.objectId);
  const searchValueType = filter?.valueType ?? condition.searchValueType;
  const filterOperator = OPERATORS[searchValueType].operators.find(
    (x) => x.displayOperator === condition.operator
  );
  const { searchValues, searchValue } = initSelectedCondition(
    condition.searchValue,
    filterOperator,
    filter
  );
  const selectedCondition = new SelectedCondition({
    filter,
    filterOperator,
    searchValues,
    searchValue,
    id: condition.id,
    isFilterApplied: true,
  });
  selectedCondition.selectedSubConditions = (condition.subConditions || []).map((subCondition) =>
    createSelectedSubCondition(
      condition.objectId,
      subCondition,
      availableConditions,
      initSelectedCondition
    )
  );
  return selectedCondition;
}

function createSelectedSubCondition(
  parentObjectId: string,
  subCondition: BaseAutomationConditionModel,
  availableConditions: EvidenceAutomationConditionItem[],
  initSelectedCondition: (
    searchValue: string[],
    filterOperator: any,
    filter: AutomationConditionItem
  ) => { searchValues?: any[]; searchValue?: string }
): SelectedCondition {
  const filter = availableConditions
    .find((x) => x.objectId === parentObjectId)
    ?.subConditionItems?.find((x) => x.objectId === subCondition.objectId);
  const searchValueType = filter?.valueType ?? subCondition.searchValueType;
  const filterOperator = OPERATORS[searchValueType].operators.find(
    (x) => x.displayOperator === subCondition.operator
  );
  const { searchValues, searchValue } = initSelectedCondition(
    subCondition.searchValue,
    filterOperator,
    filter
  );
  return new SelectedCondition({
    filter,
    filterOperator,
    searchValues,
    searchValue,
    id: null,
    isFilterApplied: true,
  });
}
